import { useCreatePath, useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { Alert, Stack, Typography } from '@mui/material';
import { SectionCard } from '../../shared/Panel';
import { forkliftInfoOf, forkliftSummary, OrderRef } from './forklift';

/**
 * Wózek w szczegółach zlecenia.
 *
 * Czynność wózkowa odsyła do swojego zlecenia głównego, zlecenie główne — do
 * swoich czynności. Powiązanie liczy API i przychodzi tylko wtedy, gdy
 * zlecenie o takim numerze naprawdę jest w banku; czynność bez niego jest
 * pokazana wprost jako niepowiązana.
 */
export const ForkliftSection = () => {
  const record = useRecordContext();
  const createPath = useCreatePath();
  if (!record) return null;
  const info = forkliftInfoOf(record);
  const summary = forkliftSummary(info);
  if (!info || !summary) return null;

  const link = (r: OrderRef, suffix = '') => (
    <Link key={r.id} to={createPath({ resource: 'user-offers', type: 'show', id: r.id })}>
      {(r.externalId ?? `#${r.id}`) + suffix}
    </Link>
  );

  return (
    <SectionCard title={summary.label}>
      {info.isActivity ? (
        <Stack spacing={1}>
          <Typography variant="body2">
            To czynność wózkowa w miejscu załadunku lub rozładunku, a nie transport.
            Nie wyznaczamy dla niej rekomendacji pojazdów i nie wystawiamy jej na giełdę.
          </Typography>
          {info.mainOrders.length > 0 ? (
            <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
              <Typography variant="body2" color="text.secondary">
                Zlecenie główne:
              </Typography>
              {info.mainOrders.map((r) => link(r))}
            </Stack>
          ) : (
            <Alert severity="warning">{summary.detail}</Alert>
          )}
        </Stack>
      ) : (
        <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
          <Typography variant="body2" color="text.secondary">
            Czynności wózkowe przy tym zleceniu:
          </Typography>
          {info.activities.map((a) =>
            link(a, a.count !== null ? ` (×${a.count})` : ''),
          )}
        </Stack>
      )}
    </SectionCard>
  );
};
